/// <amd-module name="Repos/Views/Settings/Repositories-Policies/Components/PolicyInputRadioGroup" />
import React = require("react");
import { SelectableItem } from "Repos/Views/Settings/Repositories-Policies/Contracts/Contracts";
import { IObservableValue } from "VSS/Core/Observable";
import { IListBoxItem } from "VSSUI/ListBox";
import { RadioButton, RadioButtonGroup } from "VSSUI/RadioButton";
import { getSafeId } from "VSSUI/Util";
import { FPSLink } from "VSS/Features/PlatformUI/FPSLink";

interface IPolicyInputRadioGroupProps {
    options?: IListBoxItem<string>[] | SelectableItem[];
    initialSelectedId?: string;
    isDisabled: boolean;
    onSelect: (selectedId: string) => void;
}

export const PolicyInputRadioGroup: React.FunctionComponent<IPolicyInputRadioGroupProps> = ({ options, initialSelectedId, isDisabled, onSelect }) => {
    const [selectedId, setSelectedId] = React.useState<string | IObservableValue<string> | undefined>(undefined);

    React.useEffect(() => {
        if (initialSelectedId) {
            setSelectedId(initialSelectedId);
        }
    }, [initialSelectedId]);

    const handleSelect = (selectedId: string) => {
        setSelectedId(selectedId);
        onSelect(selectedId);
    };

    return (
        <div className="policy-input-max-width">
            <RadioButtonGroup onSelect={handleSelect} selectedButtonId={selectedId} className="flex-start policy-input-radio-button-group">
                {options &&
                    (options as SelectableItem[]).map(item => (
                        <RadioButton
                            id={item.id}
                            ariaLabelledBy={item.id + "rblabel"}
                            key={item.id}
                            className="policy-input-radio-button margin-top-16"
                            disabled={isDisabled || item.disabled}
                        >
                            <div className="bolt-radio-button-label" id={getSafeId(item.id + "rblabel")}>
                                {item.link && item.linkDescription ? <span>{item.value} <FPSLink href={item.link}>{item.linkDescription}</FPSLink></span> : <span>{item.value}</span>}
                                {item.description && <span className="body-s secondary-text">{item.description}</span>}
                            </div>
                        </RadioButton>
                    ))}
            </RadioButtonGroup>
        </div>
    );
};
